import { render, staticRenderFns } from "./BackgroundSettingsPanel.vue?vue&type=template&id=5ef6d9e3"
import script from "./BackgroundSettingsPanel.vue?vue&type=script&lang=js"
export * from "./BackgroundSettingsPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports